import { CtaGoal, CtaName } from '../../../observability';
import { ICON_NAMES } from '../../../constants/icons';

export const PLANS = [
  {
    buttonText: 'Try it free',
    description:
      'Copy about the plan. Likely no longer the two lines to get in details.',
    href: '#',
    iconName: ICON_NAMES.ratingVeryHappy,
    title: 'Zapier Free',
    ctaName: CtaName.signup,
    ctaGoal: CtaGoal.signup,
  },
  {
    buttonText: 'Start 14 day free trial',
    description:
      'Copy about the plan. Likely no longer the two lines to get in details.',
    href: '#',
    iconName: ICON_NAMES.navBriefcase,
    title: 'Zapier Pro',
    ctaName: CtaName.signup,
    ctaGoal: CtaGoal.signup,
  },
  {
    buttonText: 'Get a Demo',
    description:
      'Copy about the plan. Likely no longer the two lines to get in details.',
    href: '#',
    iconName: ICON_NAMES.navExplore,
    title: 'Teams/Companies',
    ctaName: CtaName.learnMore,
    ctaGoal: CtaGoal.getMoreInformation,
  },
];
